import { MessageCodes, Result } from "../models/result";
import { getFirestore, collection, getDoc, getDocs, doc } from "firebase/firestore";

export const Privileges = {
    REPORT_PRIVILEGE: "Privilege.reportPrivilege"
}

export const hasPrivilege = async (data)=>{
    try{
        const {schoolId, privilege, userName} = data;
        const db = getFirestore();
        const privilegeRef = doc(db, 'schools', schoolId, 'privileges', privilege);
        const privilegeDoc = await getDoc(privilegeRef);
        if(privilegeDoc.exists()){
            const privilegeData = privilegeDoc.data();
            //Now get the user by userName as doc id from users sub coll
            const userRef = doc(privilegeRef, 'users', userName);
            const userDoc = await getDoc(userRef);
            if(userDoc.exists()){
                const userData = userDoc.data();
                return new Result({
                    value: true,
                });
            }else{
                return new Result({
                    message: `You do not have the privilege to perform this action`,
                    code: MessageCodes.NO_PRIVILEGE,
                });
            }
        }
        return new Result({
            message: `Privilege ${privilege} not found for school ${schoolId}`,
        })
    }catch(ex){
        return new Result({
            message: `Error checking privilege: ${ex.message}`,
        });
    }
}